module.exports = __webpack_public_path__ + "images/emoji/bread.48c91954d5f8d230de2b.png";